var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fst-italic"},[_c('p',{staticClass:"fw-bold"},[_c('i',{staticClass:"icon-info me-2"}),_c('span',{staticClass:"fs-md"},[_vm._v(" "+_vm._s(_vm.titulo))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }